import { useLazyConnectTelegramQuery, User } from '../../../features/api/apiSlice';
import Icon from '../../Icon';
import cn from "classnames";
import styles from './SocialConnect.module.css';

interface SocialConnectProps {
    user?: User;
}

const SocialConnect = ({ user }: SocialConnectProps) => {
    const [triggerConnectTelegram, { isLoading }] = useLazyConnectTelegramQuery();

    const handleConnect = async () => {
        try {
            const result = await triggerConnectTelegram();

            if (result.data && result.data.url) {
                window.location.href = result.data.url;
            } else {
                throw new Error('URL перенаправления не получен');
            }
        } catch (error) {
            console.error('Ошибка при подключении к социальной сети:', error);
        }
    };

    return (
        <div className={styles["social-connect"]}>
            <div className={styles["social-connect__container"]}>
                <div className={styles["social-connect__icon-wrapper"]}>
                    <Icon name={"telegram"} />
                </div>
                <div className={styles["social-connect__name"]}>
                    {"Telegram"}
                </div>
                {user?.telegram_id ? (
                    <div className={styles["social-connect__check-icon"]}>
                        <Icon name="done" />
                    </div>
                ) : (
                    <button
                        className={cn(
                            styles['social-connect__button'],
                            { [styles['social-connect__button_loading']]: isLoading }
                        )}
                        onClick={handleConnect}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Загрузка...' : 'Привязать'}
                    </button>
                )}
            </div>
        </div>
    );
};

export default SocialConnect;